import React, { useEffect, useState } from "react"

import { Script } from "gatsby"

// awin appends the awc parameter to the landing page url on its redirect, the mastertag reads it from
// the query string and falls back to the hash
export const getAwc = () => {
    return /[?&#]awc=([^&#]+)/i.exec(window.location.search + window.location.hash)?.[1]
}

// the mastertag persists the awc value in its own first party cookie (_aw_m_<mid>, for incentive
// publishers _aw_sn_<mid>) which it refreshes on all following page views
export const hasAwc = () => {
    return !!getAwc() || /(^|;)\s*_aw_(m|sn)_\d+=/.test(document.cookie)
}

const AwinMastertag = () => {
    const [loadMastertag, setLoadMastertag] = useState(false)

    useEffect(() => {
        setLoadMastertag(hasAwc())
    }, [])

    if (!process.env.AWIN_ADVERTISER_ID || !loadMastertag) return null

    return <Script id="awin-mastertag" src={`https://www.dwin1.com/${process.env.AWIN_ADVERTISER_ID}.js`} />
}

export default AwinMastertag
